module.exports = __webpack_public_path__ + "img/pink-2.6deb82cc.svg";